import React from "react"
import { Checkbox, Chip, CircularProgress, Divider, FormControlLabel, FormGroup, Grid, Stack, TextField, Typography } from "@mui/material";
import { useLang } from "~/hooks/useLang";
import useUserState from "~/features/User/stores/UserState";
import type { State } from "@hookstate/core";
import type { IWarehouseCheckout } from "../../interface";

interface ResponsiblesCheckinProps {
  readonly warehouseCheckout: State<IWarehouseCheckout | null>
}

export default function ResponsiblesCheckin({ warehouseCheckout }: ResponsiblesCheckinProps) {
  const { translate } = useLang()
  const { user } = useUserState()

  return (
    <>
      <Typography variant="h6" marginBottom={2}>
        {translate('Responsibles')}
      </Typography>
      <Grid container xs={12} spacing={2} marginBottom={2}>
        <Grid item xs={4}>
          <TextField
            id="outlined-start-adornment"
            fullWidth
            size="small"
            label={'Encarregado da Devolução'}
            disabled={true}
            value={`${user().get().registration} - ${user().get().representation_name}`}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            id="outlined-start-adornment"
            fullWidth
            size="small"
            label={'Encarregado da Cautela'}
            disabled={true}
            value={
              `${warehouseCheckout.get()?.checkedOutByUser?.registration
                ? `[${warehouseCheckout.get()?.checkedOutByUser?.registration}] - `
                : ''} ${warehouseCheckout.get()?.checkedOutByUser?.representationName}`}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            id="outlined-start-adornment"
            fullWidth
            size="small"
            label={'Usuário'}
            disabled={true}
            value={`${warehouseCheckout.get()?.receivedByUser?.registration
              ? `[${warehouseCheckout.get()?.receivedByUser?.registration}] - `
              : ''} ${warehouseCheckout.get()?.receivedByUser?.representationName}`}
          />
        </Grid>
      </Grid>
    </>

  )
}